import { render, staticRenderFns } from "./entry-image.vue?vue&type=template&id=3bd56e76&"
import script from "./entry-image.vue?vue&type=script&lang=js&"
export * from "./entry-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports